import { FetchAPI } from "../Main/fetchAPI";
import { TARGETS } from "../constants";

export const MasteryCriteria = {
    getMasteryCriteria: () => FetchAPI.getJson({
        urlStr: `${TARGETS}/mastery-criteria`,
    })
}